const state = {
  info: {
    match_rate : 0,
    live_rate : 0,
    child_user : 0,
    partnerMatchPriceAll : 0,
    partnerLivePriceAll : 0,
    partnerTotalPriceAll : 0,
  },
  users : [],
  child : [],
  user_code : '',
  user_code_info : {},
  startDate : '',
  endDate : ''
}

const mutations = {
  SET_INFO(state, payload) {
    state.info = payload
  },
  SET_USERS(state, payload) {
    state.users = payload
  },
  SET_CHILD(state, payload) {
    state.child = payload
  },
  SET_CODE(state, payload) {
    state.user_code = payload
  },
  SET_CODE_INFO(state, payload) {
    state.user_code_info = payload
  },
  SET_DATE(state, payload) {
    state.startDate = payload.startDate
    state.endDate = payload.endDate
  },
}

const actions = {
  setInfo({commit}, payload) {
    commit('SET_INFO', payload)
  },
  setUsers({commit}, payload) {
    commit('SET_USERS', payload)
  },
  setChild({commit}, payload) {
    commit('SET_CHILD', payload)
  },
  setCode({commit}, payload) {
    commit('SET_CODE', payload)
  },
  setCodeInfo({commit}, payload) {
    commit('SET_CODE_INFO', payload)
  },
  setDate({commit}, payload) {
    commit('SET_DATE', payload)
  },
}

const getters = {
  info: (state) => state.info,
  users: (state) => state.users,
  child: (state) => state.child,
  user_code: (state) => state.user_code,
  user_code_info: (state) => state.user_code_info,
  startDate: (state) => state.startDate,
  endDate: (state) => state.endDate,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/partner.js